module.exports = __webpack_public_path__ + "static/media/Faiz_SH.bc2db5d8.jpg";